import Cookies from "js-cookie";
import { IArticleResponse } from "../../models/get-article.model";
import { ACCESS_TOKEN } from "../../util/constants/APP_RESERVED_NAME";
import { API_HEADER } from "../../util/constants/HEADERS";

interface articleParams {
    politic_id: number;
}

export async function getArticles({ politic_id }: articleParams) {
    return await fetch(`${process.env.REACT_APP_API_URL}article/getListByPolitic/${politic_id}`, {
        method: 'GET',
        headers: {
            ...API_HEADER,                
            Authorization: `Bearer ${Cookies.get(ACCESS_TOKEN)}`
        },
    })
        .then((response) => response.json())
        .then(async (result: IArticleResponse) => {
            if (result.status) {
                return {
                    response: result.data
                }
            }
        })
        .catch(err => {
            return {
                response: []
            }
        })
}